import { push } from 'connected-react-router/immutable';
import * as React from 'react';
import { connect } from 'react-redux';

import { onClickTemplateThumbnail } from 'redux/modules/mixpanel/actions';
import { pushModal } from 'redux/modules/modal/actions';
import { getProjectTemplatesAction } from 'redux/modules/project-templates/actions';
import { projectTemplatesSelector } from 'redux/modules/project-templates/selectors';
import { Dispatch, State } from 'redux/types';
import { TemplateType } from 'types';
import { templateWizardLocation } from 'utils/routes';
import { TemplateItem } from '../../types';
import { ProjectTemplatesProps } from './ProjectTemplates';

type StateProps = Pick<ProjectTemplatesProps, 'projectTemplates'>;
export type DispatchProps = Pick<
  ProjectTemplatesProps,
  'onClickDeleteTemplate' | 'onClickTemplate' | 'onMount'
>;

const mapStateToProps = (state: State): StateProps => ({
  projectTemplates: projectTemplatesSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onClickDeleteTemplate: (templateId: string) =>
    dispatch(pushModal({ name: 'DeleteTemplate', params: { templateId } })),
  onClickTemplate: (template: TemplateItem) => {
    dispatch(
      onClickTemplateThumbnail(
        template.id,
        template.name || template.displayName,
      ),
    );
    // templates loaded by getProjectTemplatesAction in onMount come from headliner-user-service.
    // the template wizard loads the templates using podcast-service.  headlinerDefault
    // templates from headliner-user-service have to be remapped to headlinerDefaultOriginal
    // in podcast-service
    const podcastTemplateType =
      template.type === TemplateType.HEADLINER_DEFAULT
        ? TemplateType.ORIGINAL
        : template.type;

    dispatch(push(templateWizardLocation(template.id, podcastTemplateType)));
  },
  onMount: () => {
    dispatch(getProjectTemplatesAction());
  },
});

export default function(component: React.ComponentType<ProjectTemplatesProps>) {
  return connect(mapStateToProps, mapDispatchToProps)(component);
}
